import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { deleteAddress, getAddress, getAllAddress } from "api/AddressApi";
import { getCustomerId, setCustomerAddress } from "../utility/HeaderConfig";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
// import AddAddress from "./AddAddress";

const getInitialState = () => {
  const initialState = {
    customerId: getCustomerId(),
    customerName: "",
    mobileNo: "",
    pincodeNumber: "",
    stateName: "",
    address2: "",
    address1: "",
    latitude: "",
    longitude: "",
    landmark: "",
    districtName: "",
    isButtonPressed: false,
  };
  return initialState;
};

function ViewAddress(props, ref) {
  const history = useNavigate()
  const [state, setState] = useState(getInitialState());
  const [addressList, setAddressList] = useState([]);
  const [selected, setSelected] = useState(null);

  useImperativeHandle(ref, () => ({
    click: () => {
      getAddressDetails()
    }
  }))

  useEffect(() => {
    getAddressDetails();

    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    handleUpdate();
    //eslint-disable-next-line
  }, [state])

  const getAddressDetails = () => {
    let customerId = getCustomerId();
    let filter = {
      customerEntity: customerId,
    };
    getAllAddress(filter)
      .then((data) => {
        setAddressList(data.response);
      })
      .catch((err) => console.error(err));
  };

  const getAddressById = async (id) => {
    const responseData = await getAddress(id);
    if (responseData.responseCode === 200) {
      setState((prev) => ({
        ...prev,
        id: responseData.response.id,
        customerName: responseData.response.customerName,
        mobileNo: responseData.response.mobileNo,
        pincodeNumber: responseData.response.pincodeNumber,
        stateName: responseData.response.stateName,
        address2: responseData.response.address2,
        address1: responseData.response.address1,
        latitude: responseData.response.latitude,
        longitude: responseData.response.longitude,
        landmark: responseData.response.landmark,
        districtName: responseData.response.districtName,
      }));
    }
  };

  const deleteAjaxRequest = async (addressId) => {
    try {
      await deleteAddress(addressId);
      const updatedItems = addressList.filter((item) => item.id !== addressId);
      setAddressList(updatedItems);
      toast.success("Deleted Sucessfully");
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleUpdate = (id) => {
    if (id !== undefined) {
      getAddressById(id);
    }
    if (state.id) {
     const fromAccount= props.fromAccount ?  props.fromAccount : false;
      history("/AddAddress", { state: { state, fromAccount: fromAccount }  })
    }
  };

  const onChangedCheckbox = (i, value) => {
    setCustomerAddress(JSON.stringify(value));
    if(props.status){
      props?.status(false);
    }
    setSelected((prev) => (i === prev ? null : i));
  }

 return (
  <div className="address-container mt-3">
    {addressList.length > 0 ? (
      addressList.map((val, i) => (
        <div
          key={val.id}
          className={`address-card ${i === selected ? "selected" : ""}`}
        >
          <div className="address-radio">
            <input
              type="radio"
              checked={i === selected}
              onChange={() => onChangedCheckbox(i, val)}
            />
          </div>

          <div className="address-details">
            <div className="address-name-phone">
              <strong>{val.customerName}</strong> | {val.mobileNo}
            </div>
            <div className="address-full">
              {val.address1}, {val.address2 && val.address2 + ", "}
              {val.landmark && val.landmark + ", "}
              {val.districtName}, {val.stateName} - {val.pincodeNumber}
            </div>
          </div>

          <div className="address-actions">
            <button onClick={() => handleUpdate(val.id)} className="btn-edit">
              <i className="bi bi-pencil-fill" style={{ fontSize: "1.2rem" }}></i>
            </button>
            <button onClick={() => deleteAjaxRequest(val.id)} className="btn-delete">
              <i className="bi bi-trash" style={{ fontSize: "1.2rem" }}></i>
            </button>
          </div>
        </div>
      ))
    ) : (
      <p>No address available.</p>
    )}
    
  </div>
);

}

export default forwardRef(ViewAddress);
